// extracted by mini-css-extract-plugin
module.exports = {"Point":"Breakpoint_Point__eEgAF","Location":"Breakpoint_Location__OpwL3","CreatedByAvatar":"Breakpoint_CreatedByAvatar__FKyTj"};